











































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput, Uploader, PickerInput } from '@/components';
import { Button, Dialog, Toast, Popup } from 'vant';
import { FileType } from '@/common/ts/enum';
import { save } from '@/api/api';
import * as config from './config';

Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button);
@Component({
  components: {
    TextInput,
    Uploader,
    PickerInput,
  },
})
export default class Register extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  noButton = true;
  goldShow = true;
  logoText = 'Logo*';
  contentText = '品牌描述*';
  FileType = FileType;
  healthPickerData: any[] = [];
  // 需要传的参数
  healthType?: number; // 参评奖项
  title?: string = ''; // 单位名称
  lpname: string = ''; // 法人代表姓名
  lpphone?: string = ''; // 法人代表联系电话
  name: string = ''; // 申报人姓名
  phone?: string = ''; // 申报人联系电话
  cover?: any[] = []; // 单位照片
  content?: string = ''; // 单位简介

  created() {
    for (const item of this.options.healthType) {
      this.healthPickerData.push(item.shortName);
    }
  }
  fetchHealthData(e: string, index: number) {
    this.healthType = index + 1;
    console.log(e, index);
  }
  getOssImagesUrls(result: any) {
    this.cover = result;
    console.log('result', result, this.cover);
  }
  enterSave() {
    if (!this.healthType) {
      Toast.fail('请选择参评奖项');
      return false;
    }
    if (!this.title) {
      Toast.fail('请输入单位名称');
      return false;
    }
    if (!this.lpphone) {
      Toast.fail('请填写法人代表联系电话');
      return false;
    } else {
      const mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(199[0-9]{8})$/;
      const tell = /^0\d{2,3}-?\d{7,8}$/;
      if (!mobile.test(this.lpphone) && !tell.test(this.lpphone)) {
        Toast.fail('请输入正确法人代表联系方式');
        return false;
      }
    }
    if (!this.phone) {
      Toast.fail('请填写申报人联系电话');
      return false;
    } else {
      const mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(199[0-9]{8})$/;
      const tell = /^0\d{2,3}-?\d{7,8}$/;
      if (!mobile.test(this.phone) && !tell.test(this.phone)) {
        Toast.fail('请输入正确申报人联系方式');
        return false;
      }
    }
    if (this.cover && this.cover.length <= 0) {
      Toast.fail('请上传单位照片');
      return false;
    }
    if (!this.content) {
      Toast.fail('请填写单位简介');
      return false;
    }
    save(this.options.voteName, {
      ztype: this.healthType,
      title: this.title,
      lpname: this.lpname,
      lpphone: this.lpphone,
      name: this.name,
      phone: this.phone,
      cover: this.cover,
      content: this.content,
    }).then((res: any) => this.successSave(res));
  }
  successSave(res: any) {
    if (res.code === 101) {
      Toast.fail('信息填写不全！');
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.go(0);
      }, 3000);
    } else {
      Toast('未知错误请联系后台');
    }
  }
}
